import React from 'react';

import { useVideoPlayerUpdate } from "../../components/context/VideoContext";
import { gaVideoButton, gaVideoProgress } from '../../utils/gatags';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import './Video.css';

export const VideoJS = (props) => {
  const videoRef = React.useRef(null);
  const playerRef = React.useRef(null);
  const {options, onReady} = props;
 

  // get/set json data
  // const setVideo = useVideoPlayerUpdate();

  React.useEffect(() => {

    // Make sure Video.js player is only initialized once
    if (!playerRef.current) {
      // The Video.js player needs to be _inside_ the component el for React 18 Strict Mode. 
      const videoElement = document.createElement("video-js");

      videoElement.classList.add('vjs-big-play-centered');
      videoRef.current.appendChild(videoElement);


      let fireArray = [false, false, false, false, false, false, false, false, false, false ]

      const fireArrayReset = () => {
        fireArray.map((num, index) => {
          fireArray[index] = false;
        })
      }
      fireArrayReset();



      const player = playerRef.current = videojs(videoElement, options, () => {
        videojs.log('player is ready');
        onReady && onReady(player);

        let currentVideo = playerRef.current.currentSrc();

        player.on("pause", function (e) {
          gaVideoButton( currentVideo, "pause")
        });
    
        player.on("play", function (e) {
          // console.log(videoJsOptions.sources[0]);
          gaVideoButton( currentVideo, "play")
        });
         
        player.on("ended", function(){
            player.bigPlayButton.show();
            player.currentTime(0);
            player.hasStarted(false);
            player.trigger("ready");
            fireArrayReset();
        })


        player.on('timeupdate', function (e) {

          let duration = playerRef.current.duration();
          let currenttime = playerRef.current.currentTime();
          

          if ( !fireArray[0] ) {
              if ( Math.round((currenttime / duration) * 100) >= 10 && Math.round((currenttime / duration) * 100) < 20 ) {
                  // console.log("------------ 10%");
                  fireArray[0] = true
                  gaVideoProgress(10, currentVideo);
              }
          }
          if ( !fireArray[1] ) {
            if ( Math.round((currenttime / duration) * 100) >= 20 && Math.round((currenttime / duration) * 100) < 30 ) {
                  console.log("------------ 20%");
                  fireArray[1] = true
                  gaVideoProgress(20, currentVideo);
              }
          }
          if ( !fireArray[2] ) {
            if ( Math.round((currenttime / duration) * 100) >= 30 && Math.round((currenttime / duration) * 100) < 40 ) {
                  console.log("------------ 30%");
                  fireArray[2] = true
                  gaVideoProgress(30, currentVideo);
              }
          }
          if ( !fireArray[3] ) {
            if ( Math.round((currenttime / duration) * 100) >= 40 && Math.round((currenttime / duration) * 100) < 50 ) {
                  console.log("------------ 40%");
                  fireArray[3] = true
                  gaVideoProgress(40, currentVideo);
              }
          }
          if ( !fireArray[4] ) {
            if ( Math.round((currenttime / duration) * 100) >= 50 && Math.round((currenttime / duration) * 100) < 60 ) {
                  console.log("------------ 50%");
                  fireArray[4] = true
                  gaVideoProgress(50, currentVideo);
              }
          }
          if ( !fireArray[5] ) {
            if ( Math.round((currenttime / duration) * 100) >= 60 && Math.round((currenttime / duration) * 100) < 70 ) {
                  console.log("------------ 60%");
                  fireArray[5] = true
                  gaVideoProgress(60, currentVideo);
              }
          }
          if ( !fireArray[6] ) {
            if ( Math.round((currenttime / duration) * 100) >= 70 && Math.round((currenttime / duration) * 100) < 80 ) {
                  console.log("------------ 70%");
                  fireArray[6] = true
                  gaVideoProgress(70, currentVideo);
              }
          }
          if ( !fireArray[7] ) {
            if ( Math.round((currenttime / duration) * 100) >= 80 && Math.round((currenttime / duration) * 100) < 90 ) {
                  console.log("------------ 80%");
                  fireArray[7] = true
                  gaVideoProgress(80, currentVideo);
              }
          }
          if ( !fireArray[8] ) {
            if ( Math.round((currenttime / duration) * 100) >= 90 && Math.round((currenttime / duration) * 100) < 1000 ) {
                  console.log("------------ 90%");
                  fireArray[8] = true
                  gaVideoProgress(90, currentVideo);
              }
          }
          if ( !fireArray[9] ) {
              if ( Math.round((currenttime / duration) * 100) === 100 ) {
                  console.log("------------ 100%");
                  fireArray[9] = true
                  gaVideoProgress(100, currentVideo);
              }
          }



        });

      });

    // You could update an existing player in the `else` block here
    // on prop change, for example:
    } else {
      const player = playerRef.current;

      player.autoplay(options.autoplay);
      player.src(options.sources);
      player.on('timeupdate', function () {
        console.log("player.duration")
    });
      
    }
  }, [options, videoRef]);

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current;

    return () => {
      if (player && !player.isDisposed()) {
        player.dispose();
        playerRef.current = null;
      }
    };
  }, [playerRef]);

  return (
    <div data-vjs-player>
      <div ref={videoRef} />
    </div>
  );
}

export default VideoJS;